/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_BodyInputs */

const en_services_svc_money_body = /** @type {(inputs: Services_Svc_Money_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A system that finds companies that fit, researches each one, scores the fit and drafts the first message, then keeps the follow-up going. Your team spends its time on the conversations, not the searching.`)
};

const lv_services_svc_money_body = /** @type {(inputs: Services_Svc_Money_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēma, kas atrod atbilstošus uzņēmumus, izpēta katru, novērtē atbilstību, sagatavo pirmo ziņu un turpina sekot līdzi. Komanda laiku velta sarunām, nevis meklēšanai.`)
};

/**
* | output |
* | --- |
* | "A system that finds companies that fit, researches each one, scores the fit and drafts the first message, then keeps the follow-up going. Your team spends it..." |
*
* @param {Services_Svc_Money_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_body = /** @type {((inputs?: Services_Svc_Money_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_body(inputs)
	return en_services_svc_money_body(inputs)
});